var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"file-row-stats"},[_c('span',{staticClass:"gl-text-green-600",attrs:{"data-testid":"file-added-lines"}},[_vm._v(" +"+_vm._s(_vm.file.addedLines)+" ")]),_vm._v(" "),_c('span',{staticClass:"gl-text-red-500",attrs:{"data-testid":"file-removed-lines"}},[_vm._v(" -"+_vm._s(_vm.file.removedLines)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }